import { Component } from "@angular/core";
import { Location } from "@angular/common";

@Component({
    selector: "app-term-condition",
    templateUrl: "./term-condition.component.html",
    styleUrls: ["./term-condition.component.scss"],
    standalone: false,
})
export class TermConditionComponent {
    constructor(private location: Location) {}
    public email = "contact@funfigz.com";

    public goBack() {
        this.location.back();
    }
}
